/*
 * @Author: your name
 * @Date: 2021-09-06 09:14:12
 * @LastEditTime: 2021-09-24 11:46:52
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\workGroup\api.js
 */
export const api = {
  queryPersonList: '/vas/personnel/queryPersonList.json', //获取列表
  queryAccouts: '/cms/account/queryResultsByPagApi.json', // 按照条件查询账户信息

  querySecurityWorkGroup: '/cms/workgroup/querySecurityWorkGroup.json', //查询保卫工作组树
  addSecurityWorkGroup: '/cms/workgroup/addSecurityWorkGroup.json', //新增保卫工作组
  updateSecurityWorkGroup: '/cms/workgroup/updateSecurityWorkGroup.json', //修改保卫工作组
  deleteSecurityWorkGroup: '/cms/workgroup/deleteSecurityWorkGroup.json', //删除保卫工作组

  addSecurityInfo: '/cms/workgroup/addSecurityInfo.json', //新增当前保卫工作组保卫信息
  queryOutSecurityInfo: '/cms/workgroup/queryOutSecurityInfo.json',//查询不在当前保卫工作组保卫信息
  queryInSecurityInfo: 'cms/workgroup/queryInSecurityInfo.json',//查询在当前保卫工作组保卫信息
  getSecurityInfoList: '/cms/workgroup/querySecurityInfo.json',//查询保卫工作组及子节点保卫信息
  deleteSecurityInfo: '/cms/workgroup/deleteSecurityInfo.json',//删除保卫工作组保卫信息

  querySecurityWorkGroupAuthGroupList: '/cms/workgroup/querySecurityWorkGroupAuthGroupList.json',//获取权限组
  updateSecurityWorkGroupAuthGroup: '/cms/workgroup/updateSecurityWorkGroupAuthGroup.json',//修改安保工作组的权限

}